module.exports = __webpack_public_path__ + "img/cool.468bea0a.jpeg";